/**
 * @file Renders the modal that lets the user switch to another organization.
 */

import { useState } from 'react';

import { Modal } from '@components/Page';

import OrganizationsList from './OrganizationsList';

const LABEL_TITLE = 'Switch To';

type ModalControls = {
  open?: () => void;
};

type ModalRef = {
  current: ModalControls;
};

type Props = {
  modal: ModalRef;
};

/**
 * Renders the modal that lists organizations the user can switch to.
 */
const OrganizationsModal = ({ modal }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  /**
   * Opens the switch-organization modal.
   */
  modal.current.open = () => setIsOpen(true);

  /**
   * Closes the switch-organization modal.
   */
  const onClose = () => {
    setIsOpen(false);
  };

  const modalProps = {
    title: LABEL_TITLE,
    destroyOnClose: true,
    isOpen,
    onClose,
  };

  const organizationListProps = {
    /**
     * Closes the modal after the user switches organizations.
     */
    onAfterSwitch: () => onClose(),
  };

  return (
    <Modal {...modalProps}>
      <OrganizationsList {...organizationListProps} />
    </Modal>
  );
};

export default OrganizationsModal;
